import { render, staticRenderFns } from "./GiftCardDesign.vue?vue&type=template&id=523ef520&scoped=true&"
import script from "./GiftCardDesign.vue?vue&type=script&lang=js&"
export * from "./GiftCardDesign.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardDesign.vue?vue&type=style&index=0&id=523ef520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ef520",
  null
  
)

export default component.exports